<template>
  <article class="bg-modal-bg">
    <div class="flex flex-col">
      <ContentCategoryBreadcrumbs
        v-if="variant?.category"
        :type="variant?.type"
        :categories="[ variant?.category ]"
      >
        <BackButton :route-code="ROUTES.CODE.INSPIRATION" class-name="pr-5 lg:pr-10 text-light hover:underline" />
      </ContentCategoryBreadcrumbs>
      <div class="flex flex-col md:flex-row max-w-screen-xl" :style="{ 'margin-left': 'max(0px, calc(50vw - 640px))' }">
        <ContentDetailGallery :variant="variant" class="mb-0 md:mb-10" />
        <div class="w-full md:w-1/2 px-5 md:px-3 py-10">
          <ContentDetailInfo :variant="variant" class="w-full" @select:tab:comments="selectTabComments" />
        </div>
      </div>
    </div>
  </article>
</template>

<script setup>
import { ROUTES } from "@utils/routes";
import BackButton from "@components/ui/back-button";
import ContentDetailGallery from "@components/content/content-details/content-detail-gallery";
import ContentDetailInfo from "@components/content/content-details/content-detail-info";
import ContentCategoryBreadcrumbs from "@components/category/content-category-breadcrumbs";

const props = defineProps({
  variant: {
    type: Object,
    default: () => { }
  }
})

const { $eventBus } = useNuxtApp();

const selectTabComments = (id) => {
  if (id === props.variant.id) {
    $eventBus.emit('focus:input', 'comment');
  }
}

</script>
